import { useState } from "react";

import TextButton from "client/common/components/buttons/TextButton";
import Modal from "client/common/components/deprecated-modals/Modal";
import ModalLayout from "client/common/components/deprecated-modals/ModalLayout";
import Markdown from "client/common/components/content/Markdown";

import styles from "../styles/ProductLineDisclaimer.module.less";

const ProductLineDisclaimer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={styles.container}>
      <p className={styles.disclaimer}>
        This website does not provide medical advice. The information on this site is not intended
        or implied to be a substitute for professional veterinary advice, diagnosis or treatment.{" "}
        <TextButton onClick={() => setIsModalOpen(true)} icon="right">
          Learn more
        </TextButton>
      </p>
      <Modal visible={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ModalLayout>
          <ModalLayout.Header title="Content Disclaimer" onClose={() => setIsModalOpen(false)} />
          <ModalLayout.Content>
            <Markdown
              size="s"
              markdown="**THIS WEBSITE DOES NOT PROVIDE MEDICAL ADVICE.** The information on this site is not intended or implied to be a substitute for professional veterinary advice, diagnosis or treatment. All content, including text, graphics, images and information, contained on or available through this website is for general purposes only and is not meant to be complete or exhaustive, or to apply to any pet's specific medical condition.  You are encouraged to confirm any information obtained herein with reference to other sources, including by reviewing all information or course of treatment with your veterinarian. Never disregard professional veterinary advice or delay in seeking medical treatment because of content read here. Vetcove makes no representation and assumes no responsibility for the accuracy of information contained on or made available through this website, and such information is subject to change without notice."
            />
          </ModalLayout.Content>
        </ModalLayout>
      </Modal>
    </div>
  );
};

export default ProductLineDisclaimer;
